<template>
    <div>
        <Tabs sticky>
            <Tab title="勘查项" name="taskItem">
                <TaskItem/>
            </Tab>
            <Tab title="加装设备" name="taskDevice">
                <TaskDevice/>
            </Tab>
            <Tab title="隐患记录" name="taskDanger">
                <TaskDanger/>
            </Tab>
        </Tabs>
    </div>
</template>

<script>
    import {Tab, Tabs} from "vant"
    import TaskItem from "./tab/TaskItem"
    import TaskDevice from "./tab/TaskDevice"
    import TaskDanger from "./tab/TaskDanger"

    export default {
        components: {Tab, Tabs, TaskItem, TaskDevice, TaskDanger},
        props: {},
        data() {
            return {}
        },
        computed: {},
        created() {
        },
        mounted() {
        },
        methods: {},
        watch: {}
    }
</script>

<style scoped>


</style>